module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('outline'), _vm._v(" "), _c('wordy')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07fdbc72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 17
// module chunks = 0